import SparkMD5 from 'spark-md5';
import baseUrl from "../api";
import COS from "cos-js-sdk-v5";
import http from '../http';

// 获得文件md5
const getFileMD5 = (file, callback) => {
  // 声明必要的变量
  var fileReader = new FileReader(),
    // 文件每块分割2M，计算分割详情
    chunkSize = 2097152,
    chunks = Math.ceil(file.size / chunkSize),
    currentChunk = 0,
    // 创建md5对象（基于SparkMD5）
    spark = new SparkMD5();
  // 每块文件读取完毕之后的处理
  fileReader.onload = function(e) {
    // 每块交由sparkMD5进行计算
    spark.appendBinary(e.target.result);
    currentChunk++;
    // 如果文件处理完成计算MD5，如果还有分片继续处理
    if (currentChunk < chunks) {
      loadNext()
    } else {
      callback(spark.end())
    }
  };
  // 处理单片文件的上传
  function loadNext() {
    const start = currentChunk * chunkSize,
      end = start + chunkSize >= file.size ? file.size : start + chunkSize;
    fileReader.readAsBinaryString(file.slice(start, end))
  }
  loadNext()
};

const initCos = (file, clientsId, callback) => {
  // 获取文件md5
  getFileMD5(file, md5 => {
    const fileType = file.name.split('.').pop();
    const fileName = file.name; // 文件名
    const data = {
      cloud: 'tencent',
      clients_id: clientsId
    };
    // 先从自己的服务端拿到密钥生成签名
    http.post(`${baseUrl}/api/resources/token`, data)
      .then((res) => {
        const Bucket = res.resource_meta.bucket;
        const Region = res.resource_meta.region;
        // const url = `https://${Bucket}.cos.${Region}.myqcloud.com/`; // 上传地址
        // 初始化实例
        const cos = new COS({
          getAuthorization: function (options, callback) {
            callback({
              TmpSecretId: res.resource_token.credentials.tmpSecretId,
              TmpSecretKey: res.resource_token.credentials.tmpSecretKey,
              XCosSecurityToken: res.resource_token.credentials.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: res.resource_token.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: res.resource_token.expiredTime, // 时间戳，单位秒，如：1580000900
            });
          },
          UploadCheckContentMd5: true // md5校验
        });
        callback({
          cos: cos,
          name: fileName,
          md5: md5,
          type: fileType,
          Bucket: Bucket,
          Region: Region
        });
      });
  });
};

export default initCos



// WEBPACK FOOTER //
// ./src/utils/upload/tencentCos.js